

export const getAvoids = 'avoid/getAvoids';
export const avoidCapacity = 'avoid/avoidCapacity';
export const createAvoid = 'avoid/createAvoid';
export const editAvoid = 'avoid/editAvoid';
export const removeInstance = 'avoid/removeInstance';
export const deleteAvoid = 'avoid/deleteAvoid';
export const GetInstanceByIds = 'avoid/GetInstanceByIds';
export const QueryAvoid = 'avoid/QueryAvoid';
